import { AfterViewInit, Component, OnInit } from '@angular/core';
import { closedIdsKey, NotificationBarTypes, NotificationSource, rejectedIdsKey } from './notification-bar.model';
import { environment } from 'src/environments/environment';
import { NotificationDto, NotificationsService, NotificationViewModel } from '../../notifications.service';
import { ConsentsService, ConsentViewModel } from '../../consents-service';
import { forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from '../../confirm-dialog/dialog.service';
import { KnsSnackbarService } from '@kns-jasfbg/kns-snackbar';
@Component({
    selector: 'app-notification-bar',
    templateUrl: './notification-bar.component.html',
    styleUrls: ['./notification-bar.component.scss'],
    standalone: false
})
export class NotificationBarComponent implements OnInit, AfterViewInit {

  constructor(private notificationsService: NotificationsService, private consentsService: ConsentsService, private snackbar: KnsSnackbarService, private translate: TranslateService, private serviceDialog: DialogService) { }
  showNotifications = environment.showNotifications;
  isLoading = true;
  animatedItemIndex: number;
  navbarHeight: number = 65;
  headerSidebarHeight: number = 87;
  notificationsData: NotificationViewModel[];
  consentsData: ConsentViewModel[];
  isHeightSet = false;
  sendingDecisions: SendingDecisions[] = [];
  ngOnInit(): void {
    this.getAllNotifications();
  }

  ngAfterViewInit(): void {
    setInterval(() => {
      if (this.isLoading) {
        return;
      }
      this.setScrollableHeight()
    }, 200);
  }

  private setScrollableHeight() {
    const nodelist = document.getElementsByClassName("notification-bar");
    const notificationContainer = document.getElementById("notification-container");
    const notificationsHeight = notificationContainer.clientHeight
    const appContent: any = document.getElementsByClassName('app-content')[0];
    if (document.getElementById('sidebar')) {
      const sidebar = document.getElementById('sidebar')
      if (sidebar == null) {
        return;
      }
      const sidebarContent: any = sidebar.querySelector('.sidebar-content');
      if (sidebarContent != null && sidebarContent != undefined) {
        sidebarContent.style.maxHeight = `calc(-${this.getSidebarHeight(notificationsHeight)}px + 100vh)`;
        sidebarContent.style.overflow = `auto`
      }
    }
    if (nodelist.length > 0) {
      appContent.style.maxHeight = `calc(-${this.getAppContentHeight(notificationsHeight)}px + 100vh)`
    }

  }

  getNotificationBarType(type: NotificationBarTypes) {
    return type.toLowerCase();
  }

  close(id: number, index: any) {
    const closedIds = this.getClosedIds();
    closedIds.push(id);
    this.setClosedIds(closedIds);
    this.notificationsData.splice(index, 1);
    setTimeout(() => {
      const container = document.getElementById("notification-container");
      const appContent: any = document.getElementsByClassName('app-content')[0];
      appContent.style.maxHeight = `calc(-${this.navbarHeight + container.clientHeight}px + 100vh)`
      if (document.getElementById('sidebar')) {
        const sidebar = document.getElementById('sidebar')
        const sidebarContent: any = sidebar.querySelector('.sidebar-content');
        if (sidebarContent != null && sidebarContent != undefined) {
          sidebarContent.style.maxHeight = `calc(-${this.navbarHeight + this.headerSidebarHeight + container.clientHeight}px + 100vh)`
        }
      }
    }, 50)
  }

  public isSendingDecisions(consentId: number) {
    return this.sendingDecisions.find((f: any) => consentId === f.consentId);
  }

  approveConsent(consentId: number) {
    if (this.isSendingDecisions(consentId)) {
      return;
    }
    let sendingDecision: SendingDecisions = {
      consentId: consentId
    };
    this.sendingDecisions.push(sendingDecision);

    this.consentsService.approve(consentId).subscribe({
      next: () => { this.snackbar.openSuccess({message: this.translate.instant('consentApproved'), closeButton: true, duration: 3500, verticalPosition: 'top' }) },
      error: err => console.error(err),
      complete: () => {
        this.sendingDecisions = this.sendingDecisions.filter(
          f => f.consentId!== consentId
        );
        location.reload();
      }
    });
  }

  rejectConsent(consentId: number) {
    if (this.isSendingDecisions(consentId)) {
      return;
    }
    let sendingDecision: SendingDecisions = {
      consentId: consentId
    };
    this.sendingDecisions.push(sendingDecision);

    this.consentsService.reject(consentId).subscribe({
      next: () => {
        const ids = this.getRejectedConsentIds();
        ids.push(consentId);
        this.setRejectedConsents(ids);
        this.snackbar.openSuccess({message:this.translate.instant('consentRejected'), closeButton: true, duration: 3500, verticalPosition: 'top' })
      },
      error: err => console.error(err),
      complete: () => {
        this.sendingDecisions = this.sendingDecisions.filter(
          f => f.consentId !== consentId
        );
        this.getAllNotifications();
      }
    });
  }

  private getAllNotifications() {
    this.isLoading = true;
    forkJoin([this.notificationsService.getNotificationsForCurrentUser(), this.consentsService.getUserConsents()]).subscribe({
      next: res => {
        const notifications = res[0];
        const consents = res[1];
        const closedIds = this.getClosedIds();
        const rejectedIds = this.getRejectedConsentIds();
        this.notificationsData = notifications.items.filter(i => !closedIds.includes(i.id)).map((i: NotificationDto) => {
          return {
            id: i.id,
            type: i.data.type,
            modules: i.data.modules,
            htmlMessage: i.data.htmlMessage,
            title: i.data.title,
            from: i.data.from,
            to: i.data.to,
            closable: i.data.isClosable
          };
        });
        this.consentsData = consents.items.filter(i => !rejectedIds.includes(i.id)).map(c => {
          return {
            id: c.id,
            modules: c.data.modules,
            htmlMessage: c.data.htmlMessage,
            title: c.data.title,
            from: c.data.from,
            to: c.data.to
          }
        })
      }, error: err => console.error(err), complete: () => {
        this.isLoading = false
      }

    })
  }
  getModulesLabel(modules: NotificationSource[]) {
    if (modules === undefined || modules?.length == 0) {
      return '';
    }
    const result = modules.map(i => this.translateModule(i)).join(', ')
    return `${this.translate.instant('notification.modules')}: ${result}`;
  }

  getNotificationStyle(modules: NotificationSource[]) {
    if (modules === undefined || modules?.length == 0) {
      return '';
    }
    return 'with-label';
  }

  private translateModule(module: NotificationSource) {
    const result = this.translate.instant(`notification.${module}`);
    return result;
  }
  private getClosedIds(): number[] {
    const closedIdsJson = localStorage.getItem(closedIdsKey);
    if (!closedIdsJson) {
      return [];
    }
    const closedIds: number[] = JSON.parse(closedIdsJson) ?? [];
    return closedIds;
  }

  private setClosedIds(closedIds: number[]) {
    localStorage.setItem(closedIdsKey, JSON.stringify(closedIds));
  }

  private getRejectedConsentIds(): number[] {
    const json = sessionStorage.getItem(rejectedIdsKey);
    if (!json) {
      return [];
    }
    const rejectedIds: number[] = JSON.parse(json) ?? [];
    return rejectedIds;
  }

  private setRejectedConsents(consentIds: number[]) {
    sessionStorage.setItem(rejectedIdsKey, JSON.stringify(consentIds));
  }

  private getAppContentHeight(notificationsHeight) {
    return notificationsHeight + this.navbarHeight;
  }

  private getSidebarHeight(notificationsHeight) {
    return notificationsHeight + this.navbarHeight + this.headerSidebarHeight;
  }

  rejectConsentDialog(consentId: number, modules: NotificationSource[]) {
    let rejectConsent = 'rejectConsent'
    let rejectConsentDescription = 'rejectConsentDescription'

    if(modules.find(r => r.toLowerCase() == NotificationSource.Shipment)){
      rejectConsent = "rejectConsentForShipment"
    }

    this.serviceDialog.openConfirmDialog(rejectConsent, rejectConsentDescription).afterClosed().subscribe(res => {
      if (res) {
        this.rejectConsent(consentId);
      }
    });
  } 

}
export interface SendingDecisions {
  consentId: number;
}
